// src/store/index.js  
import Vue from 'vue';
import Vuex from 'vuex';
import axios from "axios";
import VuexPersistence from 'vuex-persist';
Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
    storage: window.localStorage // 或者使用 sessionStorage
});
export default new Vuex.Store({
    state: {
        tags: [
            {'title':'首页','path':'Home'}
        ],
        userPermissions: false,
        userpath: 1,
        apiUrl: 'https://yjianji.com',
        // apiUrl:'',
        pageState: {}
    },
    mutations: {
        setAuthentication(state, status) {
            state.userpath = 2;
        },
        setAuthenticationa(state, status) {
            state.userPermissions=true
        },
        savePageState(state, { pageName, pageState }) {
            state.pageState[pageName] = pageState;
        }

    },
    actions: {

    },
    getters: {
        allNotes: state => state.tags,
        allNotesa: state => state.userpath
    },
});